@if (visible()) {
  <div
    #switcherHost
    class="acting-post-switcher"
    [class.acting-post-switcher--dragging]="dragging()"
    role="region"
    [attr.aria-label]="'actingPost.switcher.regionLabel' | translate"
    [style.left.px]="position()?.left"
    [style.top.px]="position()?.top"
    [style.right]="position() ? 'auto' : null"
    [style.bottom]="position() ? 'auto' : null"
  >
    <button
      type="button"
      class="acting-post-switcher__trigger"
      [matMenuTriggerFor]="postingMenu"
      [disabled]="actingPost.switching()"
      [attr.aria-busy]="actingPost.switching()"
      [attr.aria-label]="'actingPost.switcher.label' | translate: { posting: actingPost.activeLabel() }"
      [matTooltip]="'actingPost.switcher.menuLabel' | translate"
      [matTooltipDisabled]="false"
      (pointerdown)="onPointerDown($event, switcherHost)"
    >
      <mat-icon>location_on</mat-icon>
      <span class="acting-post-switcher__label">{{ actingPost.activeLabel() }}</span>
      @if (actingPost.switching()) {
        <span class="acting-post-switcher__spinner"></span>
      } @else {
        <mat-icon class="acting-post-switcher__chevron">expand_less</mat-icon>
      }
    </button>

    <span class="visually-hidden" role="status" aria-live="polite">
      @if (actingPost.switching()) {
        {{ 'actingPost.switch.inProgress' | translate }}
      }
    </span>

    <mat-menu #postingMenu="matMenu" xPosition="before" yPosition="above" class="acting-post-switcher__menu">
      @if (actingPost.loading()) {
        <button mat-menu-item disabled>
          <span>Loading postings...</span>
        </button>
      } @else {
        @for (posting of actingPost.postings(); track posting.nodeCd) {
          <button
            mat-menu-item
            role="menuitemradio"
            [attr.aria-checked]="posting.nodeCd === actingPost.activeNodeCd()"
            [attr.aria-label]="ariaLabel(posting)"
            (click)="onSelect(posting)"
          >
            @if (posting.nodeCd === actingPost.activeNodeCd()) {
              <mat-icon class="acting-post-switcher__check">check</mat-icon>
            }
            <span>
              {{ posting.displayName }}
              @if (posting.nodeCd === actingPost.activeNodeCd()) {
                <span class="visually-hidden">{{ 'actingPost.switcher.current' | translate }}</span>
              }
            </span>
          </button>
        } @empty {
          <button mat-menu-item disabled>
            <span>No postings available</span>
          </button>
        }
      }
    </mat-menu>
  </div>
}
